export default function getValidHref(value: string, type: string) {
  switch (type) {
    case "Email":
      return `mailto:${value}`;
    case "Call":
      return `tel:${value}`;
    default:
      return value;
  }
}